module.exports = __webpack_public_path__ + "static/media/flask-poison.7642085f.svg";